import React from "react";

const Portfolio = () => {
  const projects = [
    { name: "Sweet Treats by Saju", url: "https://sweettreatsbysaju.in/" },
    { name: "Longdot", url: "https://longdot.in/" },
    { name: "Everhomes Construction", url: "https://everhomesconstruction.com/" },
    { name: "MDS", url: "https://mdstraders.in/" },
    { name: "Vestra", url: "https://vestraapparel.in/" },
    { name: "V Team", url: "https://jproduction.in/" },
  ];

  return (
    <section className="portfolio-section">

      {/* Title + Subtitle */}
      <div className="portfolio-header">
        <h2 className="portfolio-title">Our Recent Projects</h2>
        <p className="portfolio-subtitle">
          A showcase of websites and digital experiences we crafted for our
          clients across different industries.
        </p>
      </div>

      <div className="portfolio-grid">
        {projects.map((project) => (
          <a
            key={project.name}
            href={project.url}
            target="_blank"
            rel="noopener noreferrer"
            className="portfolio-card-link"
          >
            <article className="portfolio-card">
              <div className="browser-mockup">
                <div className="browser-bar">
                  <div className="dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <div className="url-bar">
                    {project.url.replace("https://", "")}
                  </div>
                </div>

                <div className="screen-content">
                  <iframe
                    src={project.url}
                    title={project.name}
                    className="portfolio-iframe"
                  />

                  <div className="iframe-click-shield"></div>

                  <div className="hover-overlay">
                    <span>Visit Live Site ↗</span>
                  </div>
                </div>
              </div>

              <h3 className="project-name-label">{project.name}</h3>
            </article>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;